export const isKA = process.env.isKA === 'true' || false;
